var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pending, time, clock, watch, timer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12,3.75c-4.549,0-8.25,3.701-8.25,8.25s3.701,8.25,8.25,8.25s8.25-3.701,8.25-8.25S16.549,3.75,12,3.75z M12,18.75 c-3.722,0-6.75-3.028-6.75-6.75c0-3.722,3.028-6.75,6.75-6.75c3.722,0,6.75,3.028,6.75,6.75C18.75,15.722,15.722,18.75,12,18.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,6.15c-0.414,0-0.75,0.336-0.75,0.75v4.788l-2.336,2.323c-0.294,0.293-0.295,0.768-0.003,1.062 c0.146,0.146,0.339,0.221,0.532,0.221c0.191,0,0.382-0.072,0.529-0.218l2.558-2.543C12.67,12.391,12.75,12.2,12.75,12V6.9 C12.75,6.486,12.414,6.15,12,6.15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.b51bb80bb27ef806848893f512feaa1a.svg";
export { ForwardRef as ReactComponent };